import { onAuthStateChanged } from 'firebase/auth'
import { useEffect } from 'react'
import useStore from '../store/useStore'
import { primaryServices } from '../utils/firebaseServiceContext'
import { getStoredImpersonationSessionId } from '../utils/impersonationService'

const useAuth = () => {
  useEffect(
    () =>
      onAuthStateChanged(primaryServices.auth, (user) => {
        const hasPendingImpersonation = !!getStoredImpersonationSessionId()
        useStore.setState({
          user,
          actorIdentity: user
            ? {
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
              }
            : undefined,
          ...(!hasPendingImpersonation
            ? {
                effectiveIdentity: user
                  ? { uid: user.uid, source: 'primary' as const }
                  : undefined,
                impersonationSession: undefined,
                identityStatus: user ? ('primary' as const) : ('initializing' as const),
              }
            : { identityStatus: 'verifying' as const }),
        })
      }),
    [],
  )
}

export default useAuth
